<template>
  <div>
    <a-row type="flex" class="row_item">
      <a-col :span="2" style="padding-top: 15px">
        <span v-if="index >= 0">{{ index + 1 }}、电汇付款</span>
        <span v-else>电汇付款</span>
      </a-col>
      <a-col :span="22">
        <div :title="item.name">
          <span style="display: block; padding-left: 16px;">
            <span class="desc">合同类型：{{ item.sell_contract_id > 0 ? '购销合同' : '普通合同' }}</span>
            <span class="desc">系统编号：{{ item.sell_contract_id > 0 ? item.sell_contract_number : item.contract_number }}</span>
            <span class="desc" >客户：{{ item.client }}</span>
            <span class="desc">金额：{{ (item.amount).toFixed(4) | numberFormat }}</span>
            <span class="desc">币种：{{ dictionaries.currency[item.currency] }}</span>
            <span class="desc">购汇汇率：{{ (item.purchase_rate).toFixed(4) | numberFormat }}</span>
            <span class="desc">实付人民币金额：{{ (item.amount_cny).toFixed(4) | numberFormat }}</span>
            <span class="desc">款项性质：{{ dictionaries.trade_payment_nature[item.method] }}</span>
            <span class="desc">已开启审批：
              <a-popconfirm
                title="确定开启审批吗?"
                :disabled="item.is_approval_needed"
                @confirm="() => approvalNeeded(item, 'trade_payment', item.status === 3)">
                <a-switch checked-children="是" un-checked-children="否" :checked="item.is_approval_needed" :disabled="item.is_approval_needed"/>
              </a-popconfirm>
            </span>
            <span class="desc" v-if="item.is_approval_needed">审批状态：<span :class="statusText[item.status < 0 ? 0 : item.status][0]">{{ item.is_approval_needed ? (dictionaries.approval_result[item.status] ? dictionaries.approval_result[item.status] : '无') : un_approval_needed_text }}</span></span>
            <span class="desc" v-action:add>已存档：
              <a-popconfirm
                title="确定存档吗?"
                :disabled="item.is_archived"
                @confirm="() => handleArchived(item, 'payment')">
                <a-switch checked-children="是" un-checked-children="否" :checked="item.is_archived" :disabled="item.is_archived"/>
              </a-popconfirm>
            </span>
            <span class="desc">支付时间：{{ item.pay_time | dayjs }}</span>
            <span class="desc" v-if="item.create_by">创建人：{{ item.create_by }}</span>
            <span class="desc">创建时间：{{ item.create_time | dayjs }}</span>
          </span>
          <span style="padding-left: 16px;" class="desc" v-if="item.remark">备注：{{ item.remark }}</span>
          <div style="padding-left: 16px;" v-if="!item.is_archived && ((item.is_approval_needed && item.status !== 1) || (!item.is_approval_needed)) && edit">
            <span class="desc">操作:</span>
            <span class="ope">
              <span @click="handleEditRecord(item, 'payment')" v-if="!item.is_approval_needed">编辑</span>
              <a-popconfirm
                title="确定删除吗?"
                @confirm="() => handleDelete(item, 'payment')">
                <span v-if="((item.is_approval_needed && item.status !== 1) || (!item.is_approval_needed))">删除</span>
              </a-popconfirm>
              <a-popconfirm
                v-if="item.is_approval_needed && item.status === 3"
                title="确定重启审批?"
                @confirm="() => approvalNeeded(item, 'trade_payment', true)">
                <span>重启审批</span>
              </a-popconfirm>
            </span>
          </div>
          <div v-if="item.attachment.length > 0">
            <a-collapse :bordered="false">
              <template #expandIcon="props">
                <a-icon type="caret-right" :rotate="props.isActive ? 90 : 0" />
              </template>
              <a-collapse-panel key="1" header="附件" :style="customStyle">
                <a v-for="(a) in item.attachment" :key="a.id" :href="a.url" target="_blank" class="desc"><a-icon type="file" theme="filled" /> {{ a.name }}</a>
              </a-collapse-panel>
            </a-collapse>
          </div>
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { Dictionaries } from '@/common/AllConstant'
import ContractRecord from '../modules/ContractRecord'

export default {
  name: 'PaymentInfo',
  components: {
    ContractRecord
  },
  props: {
    item: {
      type: Object,
      default: () => {
        return null
      }
    },
    index: {
      type: Number,
      default: 0
    },
    edit: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      customStyle: 'background: #f7f7f7;border-radius: 4px;margin-bottom: 1px;border: 0;overflow: hidden',
      dictionaries: Dictionaries,
      recordVisible: false,
      contractRecordVisible: false,
      un_approval_needed_text: '未开启审批',
      inventoryTypeList: [
        '入库',
        '出库',
        '平账'
      ],
      statusText: {
        0: ['none', '无'],
        1: ['waiting', '审批中'],
        2: ['pass', '通过'],
        3: ['un_pass', '驳回']
      }
    }
  },
  methods: {
    handleArchived (item, type) {
      this.$emit('handleArchived', item, type)
    },
    handleEditRecord (item, type) {
      this.$emit('handleEditRecord', item, type)
    },
    handleDelete (item, type) {
      this.$emit('handleDelete', item, type)
    },
    approvalNeeded (item, type, approval_again) {
      this.$emit('approvalNeeded', item, type, approval_again)
    }
  }
}
</script>

<style scoped>
.desc {
  padding-right: 20px;
  height: 40px;
  line-height: 40px;
  display: inline-block;
}
.row_item {
  border-bottom: 1px solid #eeeeee;
  padding: 10px 20px;
  background-color: #f7f7f7;
  margin-top: 5px;
  border-radius: 10px;
}
.ope>span:hover {
  color: #2a99ff;
  cursor: pointer;
}
.ope>span:first-child {
  padding-left: 0px;
  height: 40px;
  line-height: 40px;
}
.ope>span:not(:first-child) {
  padding-left: 20px;
  height: 40px;
  line-height: 40px;
}
.content {
  /*color: #00A0E9;*/
  /*font-weight: bolder*/
}
.none {
  color: #333333;
}
.waiting {
  color: yellowgreen;
}
.pass {
  color: green;
}
.un_pass {
  color: red;
}
.space {
  margin-top: 5px;
  overflow-x: auto;
}
.important-content {
  font-weight: bold;
}
</style>
